var map = {
	"./404.svg": "sEM+",
	"./action.svg": "H5ut",
	"./add.svg": "58n+",
	"./addcustom.svg": "O7m8",
	"./allocate.svg": "zIuv",
	"./analysis.svg": "/tUJ",
	"./arrow_bottom.svg": "8FOf",
	"./batch.svg": "ccNl",
	"./bill.svg": "hOaM",
	"./billControl.svg": "DYHf",
	"./billquery.svg": "hzOP",
	"./bug.svg": "SVqS",
	"./clipboard.svg": "KO/S",
	"./control.svg": "oiHZ",
	"./controls.svg": "f4jD",
	"./dashboard.svg": "BCGP",
	"./dialogies.svg": "7AoZ",
	"./dialogise.svg": "Bhyc",
	"./download.svg": "+H2/",
	"./edit.svg": "ql+d",
	"./education.svg": "wyC6",
	"./email.svg": "+4G4",
	"./empty.svg": "yjTQ",
	"./enter.svg": "HS6h",
	"./excel.svg": "OLl3",
	"./export.svg": "gmuv",
	"./exports.svg": "kg1X",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./guide.svg": "z74U",
	"./hamburger.svg": "PHf5",
	"./import.svg": "XteN",
	"./kiduser.svg": "Frio",
	"./language.svg": "+Dip",
	"./life.svg": "4iN5",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./logout.svg": "KvOj",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./note.svg": "yZSt",
	"./notice.svg": "MqGM",
	"./order.svg": "gYtG",
	"./packageOrder.svg": "Cp0K",
	"./password.svg": "QjmH",
	"./paycheck.svg": "+Mec",
	"./pdf.svg": "M8Oc",
	"./person.svg": "iMuv",
	"./plbdkh.svg": "tlf6",
	"./plsim.svg": "LiCg",
	"./plsms.svg": "/kF9",
	"./plxf.svg": "3fvS",
	"./purchase.svg": "BM4V",
	"./rank.svg": "8L7i",
	"./renew.svg": "wyG+",
	"./rolemanage.svg": "YFyk",
	"./search.svg": "Bx0U",
	"./shopping.svg": "jRi0",
	"./sim.svg": "Mz8m",
	"./statistics.svg": "2O5N",
	"./success.svg": "C5yd",
	"./sysmanage.svg": "yi0t",
	"./tab.svg": "Jysk",
	"./task.svg": "EK3d",
	"./tip.svg": "6+87",
	"./traffic.svg": "hQzb",
	"./tree-table.svg": "myHh",
	"./usagequery.svg": "Nl7p",
	"./user.svg": "VdD3",
	"./usericon.svg": "7ylu",
	"./voice.svg": "JV+L",
	"./wechat.svg": "pYJ+",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 42